module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-2020/0059.jpg?v=11dfdbb3";